export default __webpack_public_path__ + "static/media/busari.6ccc34a4.jpg";